var exports = {
  "n": "IncludeTargetIcon__hfCiAb",
  "h": "ExcludeTargetIcon__PW09ui",
};

module.exports = exports;
